<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/120FrL2/tc-custom/9780226327013.jpg?1726617321350" alt="This image is the cover for the book Wasted World"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wasted World
      </h1>
      <p class="bookDescription body article font2">
        <b>This biologist’s “monumental <i>cri de Coeur</i>” for our planet offers a holistic view of our species, the waste we produce, and a path toward sustainability (<i>Nature</i>).</b><br/>  <br/> In <i>Wasted World</i>, Rob Hengeveld traces the entwined histories of population growth and resource consumption to reveal how our global waste crises came about. As Hengeveld explains, human life depends on energy, which we first obtained through food. Later, we supplemented this with energy from water, wind, animals, and finally fossil fuels, as one source after another fell short of our ever-growing needs. Greater energy consumption has created greater waste, including the atmospheric waste that is driving climate change. As we face a web of interconnected problems, addressing them individually will not work. Instead, Hengeveld argues, we need to tackle their common cause: our staggering population growth.<br/>  <br/> A practical look at the sustainability of our planet from a biologist and expert in the abundances and distributions of species, <i>Wasted World </i>examines the whole process of using, wasting, and exhausting energy and material resources. And by elucidating the complexity of the causes of our current global state, Hengeveld offers us a way forward.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rob Hengeveld
      </h2>
      
      <p class="authorDescription body article">Rob Hengeveld is affiliated with the Centre for Ecosystem Studies of Alterra, Wageningen, the Netherlands, and was an honorary professor in the Department of Animal Ecology at the Vrije Universiteit, Amsterdam.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?29dc5ba9